import { I18nUserDefinedConfig } from '@app/i18n/i18n-user-defined.types';
import { ENTITY_TYPES, ServiceIdentifyType } from '@app/shared/types';

export const SUPPORT_USER_DEFINED_I18N_CONFIG: Record<
  ServiceIdentifyType,
  I18nUserDefinedConfig
> = {
  [ENTITY_TYPES.ORDER]: {
    userDefinedPaths: [
      'site_name',
      'vendor_name',
      'inventory_items.[].item_name',
      'inventory_items.[].gl_account_name',
      'inventory_items.[].major_category_name',
      'inventory_items.[].minor_category_name',
      'inventory_items.[].measure_description',
      'unavailable_items.[].item_name',
      'unavailable_items.[].measure_description',
    ],
    alias: [ENTITY_TYPES.FILTERED_ORDER],
  },
  [ENTITY_TYPES.INVENTORY_ITEM_VENUE]: {
    userDefinedPaths: [
      'name',
      'gl_account.name',
      'measures.[].description',
      'reporting_category_major.name',
      'reporting_category_minor.name',
      'vendors.[].name',
      'vendors.[].measures.[].description',
      'physical_count_measures.[].description',
    ],
    specialI18nConfig: {
      enableRevert: true,
    },
  },
  [ENTITY_TYPES.SITE]: {
    userDefinedPaths: ['name'],
  },
  [ENTITY_TYPES.VENDOR]: ['name', 'measures.[].description'],
  [ENTITY_TYPES.TRANSFER]: {
    userDefinedPaths: [
      'site_name',
      'site_name_to',
      'inventory_items.[].item_name',
      'inventory_items.[].gl_account_name',
      'inventory_items.[].major_category_name',
      'inventory_items.[].minor_category_name',
      'inventory_items.[].measure_description',
      'unavailable_items.[].item_name',
    ],
    alias: [
      ENTITY_TYPES.FILTERED_TRANSFER,
      ENTITY_TYPES.INCOMPLETE_TRANSFER,
      ENTITY_TYPES.TRANSFER_REQUEST,
    ],
  },
  [ENTITY_TYPES.TRANSFER_GROUP_TEMPLATE]: {
    userDefinedPaths: ['site_name'],
  },
  [ENTITY_TYPES.TRANSFER_GROUP]: {
    userDefinedPaths: [
      'site_name',
      'transfer_items.[].site_name',
      'transfer_items.[].site_name_to',
    ],
  },
  [ENTITY_TYPES.STAND_WORKSHEET]: {
    userDefinedPaths: ['site_name', 'event_name'],
  },
  [ENTITY_TYPES.PRODUCT]: {
    userDefinedPaths: [
      'name',
      'reporting_category.major_reporting_category.name',
      'reporting_category.minor_reporting_category.name',
    ],
  },
  [ENTITY_TYPES.STAND_WORKSHEET_ITEM]: {
    userDefinedPaths: ['inventory_item_name', 'product_name'],
  },
  [ENTITY_TYPES.EVENTS]: {
    userDefinedPaths: ['name', 'available_sites.[].name'],
  },
  [ENTITY_TYPES.EVENT_TYPE]: ['name'],
  [ENTITY_TYPES.INVENTORY_COUNT]: {
    userDefinedPaths: [
      'inventory_count_items.[].reporting_category_major.name',
      'inventory_count_items.[].reporting_category_minor.name',
      'inventory_count_items.[].counts.[].measure_description',
      'inventory_count_items.[].name',
    ],
    specialI18nConfig: {
      enableRevert: true,
    },
  },
  [ENTITY_TYPES.COMMISSION_RATE]: {
    userDefinedPaths: ['name'],
  },
  [ENTITY_TYPES.HAWKER_SESSION]: {
    userDefinedPaths: [
      'site_name',
      'products.[].name',
      'event.name',
      'commission_rate.name',
    ],
    alias: [ENTITY_TYPES.HAWKER_SESSION_ADMIN],
  },
  [ENTITY_TYPES.HAWKER_COMMISSARY_ASSIGNMENT_HISTORY]: {
    userDefinedPaths: ['commissary_assignments.[].site_name', 'event_name'],
  },
};
